/** UI locales for OMS dashboard + client portal (Layer 1). */
export type AppUiLocale = 'en' | 'zh-Hant' | 'zh-CN'

export const APP_UI_LOCALE_STORAGE_KEY = 'oms_ui_locale'

export const APP_UI_LOCALE_OPTIONS: { value: AppUiLocale; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'zh-Hant', label: '繁體中文' },
  { value: 'zh-CN', label: '简体中文' },
]

export type AppUiNamespace = 'common' | 'dashboard' | 'customerPortal'

export function normalizeAppUiLocale(raw: string | null | undefined): AppUiLocale {
  const v = (raw ?? '').trim()
  if (v === 'zh-Hant' || v === 'zh-TW' || v === 'zh-HK' || v === 'zh_TW') {
    return 'zh-Hant'
  }
  if (v === 'zh-CN' || v === 'zh_CN' || v === 'zh-cn' || v === 'zh') {
    return 'zh-CN'
  }
  return 'en'
}

export function readStoredAppUiLocale(): AppUiLocale {
  try {
    const stored = localStorage.getItem(APP_UI_LOCALE_STORAGE_KEY)
    if (stored) {
      return normalizeAppUiLocale(stored)
    }
    if (typeof navigator !== 'undefined') {
      const browserLocales = [
        navigator.language,
        ...(navigator.languages ?? []),
      ]
      for (const raw of browserLocales) {
        const normalized = normalizeAppUiLocale(raw)
        if (normalized !== 'en' || raw.toLowerCase().startsWith('en')) {
          return normalized
        }
      }
    }
  } catch {
    /* quota / private mode */
  }
  return 'en'
}

export function persistAppUiLocale(locale: AppUiLocale): void {
  try {
    localStorage.setItem(APP_UI_LOCALE_STORAGE_KEY, locale)
  } catch {
    /* quota / private mode */
  }
}

/** BCP 47 tag for `Intl` / `toLocaleDateString`. */
export function appUiDateLocale(locale: AppUiLocale): string {
  if (locale === 'zh-Hant') return 'zh-Hant'
  if (locale === 'zh-CN') return 'zh-CN'
  return 'en-US'
}

export function isChineseAppUiLocale(locale: AppUiLocale): boolean {
  return locale === 'zh-Hant' || locale === 'zh-CN'
}
